<template>
  <div class="BaseHistory">
    <v-container fluid>
      <v-row v-if="previewPanel">
        <v-col cols="6" lg="6" md="6" sm="12" xs="12">
          <BaseStoreFileList
              :storeDocItemId="storeDocItemId"
              :previewPanel.sync="previewPanel"
              :windowHeight="windowHeight"
          ></BaseStoreFileList>
        </v-col>
        <v-col cols="6" lg="6" md="6" sm="12" xs="12">
          <BaseStoreFilePreView
              :storeDocItemId="storeDocItemId"
              :windowHeight="windowHeight"
          />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12" lg="12" md="12" sm="12" xs="12">
          <BaseStoreFileList
              :storeDocItemId="storeDocItemId"
              :previewPanel.sync="previewPanel"
              :windowHeight="windowHeight"
          ></BaseStoreFileList>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";
import BaseStoreFileList from "@/components/BaseStoreFile/BaseStoreFileList";
import BaseStoreFilePreView from "@/components/BaseStoreFile/BaseStoreFilePreView";

export default {
  name: 'BaseStoreFile',
  props: {
    'storeDocItemId': {default: null},
    'windowHeight': {default: 800},
  },
  components: {
    BaseStoreFileList,
    BaseStoreFilePreView,
  },
  computed: {
  },
  created() {
  },
  mounted() {
  },
  data() {
    return {
      previewPanel: true,
      activeHistoryId: null,
    }
  },
};
</script>
